var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M802-128 690-244H240q-59.29 0-99.65-40.35Q100-324.71 100-384q0-71 54-114t117-31q.33-19.78 9.67-48.89Q290-607 304-626L166-764l15-15 636 636-15 15ZM240-264h428L318-614q-13 20-22 49.5T283-507l-51 4q-48 4-80 37.68T120-384q0 49.71 35.14 84.86Q190.29-264 240-264Zm252-176Zm312 182-15-16q21-13 36-35.51 15-22.51 15-50.49 0-40.32-27.84-68.16Q784.32-456 744-456h-66l-6-65q-7-74-62-124.5T479.78-696q-24.47 0-47.12 6Q410-684 389-673l-14-15q32-16 54.65-22 22.64-6 50.35-6 81.27 0 142.14 54.36Q683-607.27 692-528v52h32q55-8 95.5 26.5T860-360q0 28-13 54t-43 48ZM589-474Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOff);
export default __webpack_public_path__ + "static/media/cloud_off.925f042820c53973738f876e5d857c1e.svg";
export { ForwardRef as ReactComponent };